// import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'

import { Content } from '../BlogPostCard/BlogPostCardShards'

export const HeroWrapper = styled.div`
  background-color: #fbf8ef;
  width: 100%;
  height: fit-content;
`

export const Inner = styled.div`
  background-color: #fbf8ef;
  width: 100%;
  padding: 2rem 1.5rem;
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;

  ${mediaQueryUp('m')} {
    max-width: 560px;
    margin: 0 auto;
  }

  @media (min-width: 768px) {
    max-width: 1280px;
    margin: unset;
    flex-wrap: nowrap;
    gap: 1rem;
  }

  ${mediaQueryUp('l')} {
    padding: 2rem 2.5rem;
  }

  @media (min-width: 1200px) {
    gap: 2rem;
  }
`

export const Main = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
    min-height: calc(102px * 3 + 24px * 2);
    max-height: calc(170px * 3 + 24px * 2);
  }

  @media (min-width: 1200px) {
    min-height: calc(102px * 3 + 48px * 2);
    max-height: calc(170px * 3 + 48px * 2);
  }

  ${Content} {
    padding: 0 0.75rem 0.5rem;
  }
`

export const Latest = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;

  @media (min-width: 768px) {
    gap: 0;
    min-height: 100%;
  }
`

export const Tile = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray[300]};
  height: calc(100% / 3 - (32px / 3));
  flex-grow: 0;
  min-height: 102px;
  flex-shrink: 1;
  display: flex;
  width: 100%;

  @media (min-width: 1200px) {
    height: calc(100% / 3 - (48px / 3));
  }
`
